const API_URL = process.env.REACT_APP_API_URL;

export const API_ROUTES = {
    GIT_PUSH: `${API_URL}/api/gitpush`,
}

export const APP_ROUTES = {
    EPICERIE: '/epicerie',
    PRODUCTEURS: '/producteurs',
    PRODUITS: '/produits',
    ACCESSIBILITY: '/accessibility',
    CONFIDENTIALITY: '/confidentiality',
    SITEMAP: '/sitemap',
    WORKING: '/enconstruction',
    ADMIN_PANEL: '/adminpanel'
}

// Lien Google Maps de la boutique
export const MAPS_URL = 'https://www.google.com/maps/place/Epicerie+BAsique/@46.0349105,4.0700276,17z';

// Crédit en pied de page. Laisser vide tant que l'adresse du site n'est pas connue :
// le nom s'affiche alors sans lien.
export const AUTHOR_NAME = 'Bruce Traccard';
export const AUTHOR_SITE_URL = '';
